<nf-table-layout
  tableTitle="Historical Balance Comparison"
  [isSectionTitle]="true"
  [gridOptions]="gridOptions"
  [modules]="gridModules"
  [data]="data$ | async"
  [autoResizeGrid]="false"
  hideTitle
  hideSearch
  hideClearAll
>
  <nf-table-properties [currentProperties]="propertiesTitle" [isOpen]="false">
    <div class="quick-filters">
      <label>
        Only Differences
        <nf-toggle
          elId="only-differences"
          [(ngModel)]="onlyDifferences"
          (ngModelChange)="reloadData()"
          states="true"
        ></nf-toggle>
      </label>
      <label *ngIf="_position?.posTypeCode === 'Cash'">
        Only Cleared
        <nf-toggle
          elId="cleared-only"
          [(ngModel)]="clearedOnly"
          (ngModelChange)="reloadData()"
          states="true"
        ></nf-toggle>
      </label>
    </div>
  </nf-table-properties>
</nf-table-layout>
